import { Icon, Pivot, PivotItem } from "@fluentui/react";

import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { PremiumType } from "types/types";
import { useSelector } from "../../../store/hooks";
import { setPremiumBookingTab } from "../../../store/vehicle";
import { Accident } from "./Accident";
import { Assistance } from "./Assistance";
import { EnginePowerTax } from "./EnginePowerTax";
import { FleetLegalProrata } from "./FleetLegalProrata";
import { General } from "./General";
import { Hull } from "./Hull";
import { HullBasic } from "./HullBasic";
import { HullOnLandProrata } from "./HullOnLandProrata";
import { Legal } from "./Legal";
import { MachineryBreakdownProrata } from "./MachineryBreakdownProrata";
import { Mtpl } from "./Mtpl";

export const Tabs = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const tab = useSelector((s) => s.vehicle.premiumBookingTab);
  const isTradeLicensePlate = useSelector(
    (s) => s.vehicle.vehicle.isTradeLicensePlate
  );
  const vehicleAppSettings = useSelector((s) => s.vehicle.vehicleAppSettings);

  return (
    <Pivot
      selectedKey={tab}
      onLinkClick={(item) => {
        if (!item) return;
        dispatch(setPremiumBookingTab(item.props.itemKey));
      }}
    >
      <PivotItem
        headerText="General"
        itemKey="general"
        onRenderItemLink={() => (
          <>
            <StyledIcon iconName="Globe" />
            {t("bfm.vehicleForm.pivotGeneral.label")}
          </>
        )}
      >
        <General />
      </PivotItem>
      {vehicleAppSettings.VEHICLE_PREMIUM_TYPES.includes(PremiumType.MTPL) && (
        <PivotItem
          headerText="MTPL"
          itemKey="mtpl"
          onRenderItemLink={() => (
            <>
              <StyledIcon iconName="Car" />
              {t("bfm.vehicleForm.pivotMtpl.label")}
            </>
          )}
        >
          <Mtpl />
        </PivotItem>
      )}
      {!isTradeLicensePlate &&
        vehicleAppSettings.VEHICLE_PREMIUM_TYPES.includes(
          PremiumType.HORSE_POWER
        ) && (
          <PivotItem
            headerText="Engine Power Tax"
            itemKey="enginePowerTax"
            onRenderItemLink={() => (
              <>
                <StyledIcon iconName="Money" />
                {t("bfm.vehicleForm.pivotEnginePowerTax.label")}
              </>
            )}
          >
            <EnginePowerTax />
          </PivotItem>
        )}
      {vehicleAppSettings.VEHICLE_PREMIUM_TYPES.includes(
        PremiumType.ACCIDENT
      ) && (
        <PivotItem
          headerText="Accident"
          itemKey="accident"
          onRenderItemLink={() => (
            <>
              <StyledIcon iconName="Warning" />
              {t("bfm.vehicleForm.pivotAccident.label")}
            </>
          )}
        >
          <Accident />
        </PivotItem>
      )}
      {vehicleAppSettings.VEHICLE_PREMIUM_TYPES.includes(
        PremiumType.ASSISTANCE
      ) && (
        <PivotItem
          headerText="Assistance"
          itemKey="assistance"
          onRenderItemLink={() => (
            <>
              <StyledLaIcon className={"las la-hands-helping"}></StyledLaIcon>
              {t("bfm.vehicleForm.pivotAssistance.label")}
            </>
          )}
        >
          <Assistance />
        </PivotItem>
      )}
      {vehicleAppSettings.VEHICLE_PREMIUM_TYPES.includes(PremiumType.LEGAL) && (
        <PivotItem
          headerText="Legal"
          itemKey="legal"
          onRenderItemLink={() => (
            <>
              <StyledLaIcon className={"la la-balance-scale"}></StyledLaIcon>
              {t("bfm.vehicleForm.pivotLegal.label")}
            </>
          )}
        >
          <Legal />
        </PivotItem>
      )}
      {vehicleAppSettings.VEHICLE_PREMIUM_TYPES.includes(PremiumType.HULL) && (
        <PivotItem
          headerText="Hull"
          itemKey="hull"
          onRenderItemLink={() => (
            <>
              <StyledLaIcon className={"las la-anchor"}></StyledLaIcon>
              {t("bfm.vehicleForm.pivotHull.label")}
            </>
          )}
        >
          <Hull />
        </PivotItem>
      )}
      {vehicleAppSettings.VEHICLE_PREMIUM_TYPES.includes(
        PremiumType.HULL_BASIC
      ) && (
        <PivotItem
          headerText="Hull Basic"
          itemKey="hullBasic"
          onRenderItemLink={() => (
            <>
              <StyledLaIcon className={"las la-dharmachakra"}></StyledLaIcon>

              {t("bfm.vehicleForm.pivotHullBasic.label")}
            </>
          )}
        >
          <HullBasic />
        </PivotItem>
      )}
      {vehicleAppSettings.VEHICLE_PREMIUM_TYPES.includes(
        PremiumType.FLEETLEGAL_PRORATA
      ) && (
        <PivotItem
          headerText="Fleet Legal"
          itemKey="fleetLegalProrata"
          onRenderItemLink={() => (
            <>
              <StyledLaIcon className={"las la-car-side"}></StyledLaIcon>
              {t("PremiumType.FLEETLEGAL_PRORATA")}
            </>
          )}
        >
          <FleetLegalProrata />
        </PivotItem>
      )}
      {vehicleAppSettings.VEHICLE_PREMIUM_TYPES.includes(
        PremiumType.HULL_ON_LAND_PRORATA
      ) && (
        <PivotItem
          headerText="Hull on Land"
          itemKey="hullOnLandProrata"
          onRenderItemLink={() => (
            <>
              <StyledLaIcon className={"las la-parking"}></StyledLaIcon>
              {t("PremiumType.HULL_ON_LAND_PRORATA")}
            </>
          )}
        >
          <HullOnLandProrata />
        </PivotItem>
      )}
      {vehicleAppSettings.VEHICLE_PREMIUM_TYPES.includes(
        PremiumType.MACHINERY_BREAKDOWN_PRORATA
      ) && (
        <PivotItem
          headerText="Machinery Breakdown"
          itemKey="machineryBreakdownProrata"
          onRenderItemLink={() => (
            <>
              <StyledLaIcon className={"las la-car-crash"}></StyledLaIcon>
              {t("PremiumType.MACHINERY_BREAKDOWN_PRORATA")}
            </>
          )}
        >
          <MachineryBreakdownProrata />
        </PivotItem>
      )}
    </Pivot>
  );
};

const StyledIcon = styled(Icon)`
  color: ${(p) => p.theme.palette.themePrimary};
  margin-right: 5px;
  font-size: 16px;
`;

const StyledLaIcon = styled.i`
  font-size: 20px;
  margin-right: 5px;
  color: ${(p) => p.theme.palette.themePrimary};
`;
